import { ref } from 'vue';

export const useAgentActionMenuUtils = () => {
  const menuOpeningDirection = ref({
    self: null,
    anchor: null,
  } as {
    self: null | 'top left' | 'top right';
    anchor: null | 'top left' | 'top right';
  });

  const beforeShow = (pointerEvent: MouseEvent) => {
    menuOpeningDirection.value = {
      self: pointerEvent.screenX < window.innerWidth / 2 ? 'top left' : 'top right',
      anchor: pointerEvent.screenX < window.innerWidth / 2 ? 'top right' : 'top left',
    };
  };

  return { beforeShow, menuOpeningDirection };
};
